export default __webpack_public_path__ + "static/media/categories.ba30900a.svg";